// extracted by mini-css-extract-plugin
export var button = "eduWorkButton-module--button--FI0Nr";
export var container = "eduWorkButton-module--container--mvRTD";
export var description = "eduWorkButton-module--description--XvyCm";
export var descriptionBlock = "eduWorkButton-module--descriptionBlock---j8Ea";
export var edu = "eduWorkButton-module--edu--C8JYG";
export var rounded = "eduWorkButton-module--rounded--F7BR1";
export var sbShowMain = "eduWorkButton-module--sb-show-main--p54vm";
export var slideBlock = "eduWorkButton-module--slideBlock--4oUwo";
export var totara = "eduWorkButton-module--totara--989HY";
export var work = "eduWorkButton-module--work--eIANj";